import formatBorrowerName from '../../../../../helpers/formatBorrowerName';
import { useImportDocumentStore } from '../../../../../store';
import getChangeFieldName from './getChangeFieldName';

export default function saveSelectedResultAndRecordChange(
  selectedResult,
  type,
  updateDocument
) {
  const isBorrower = type.includes('orrower');

  const {
    setSelectedBorrower,
    setSelectedCoborrower,
    setSelectedAgent,
    setSelectedCarrier,
    setSelectedBroker,
    setImportDocumentChanges,
    importDocumentChanges,
  } = useImportDocumentStore.getState();

  const currentEntity = {
    name: isBorrower ? formatBorrowerName(selectedResult) : selectedResult.name,
    id: selectedResult.id,
  };

  const change = {
    field: getChangeFieldName(type),
    original_value: null,
    modified_value: selectedResult.id,
  };

  switch (type) {
    case 'Borrower':
      setSelectedBorrower(currentEntity);
      break;
    case 'Coborrower':
      setSelectedCoborrower(currentEntity);
      break;
    case 'Agent':
      setSelectedAgent(currentEntity);
      break;
    case 'Carrier':
      setSelectedCarrier(currentEntity);
      break;
    case 'Broker':
      setSelectedBroker(currentEntity);
      break;
    default:
      break;
  }

  setImportDocumentChanges([...importDocumentChanges, change]);

  updateDocument({
    key: getChangeFieldName(type),
    value: selectedResult.id,
  });
}
